// Entrypoint for theme JS – we forward existing global theme.js then extend

// Lazy load ijewel when trigger clicked
import { mountViewer } from './ijewel-mini.js';

document.addEventListener('click', async (e) => {
  const trigger = e.target.closest('[data-webgi-viewer], .ijewel-inline-trigger');
  if (!trigger) return;
  e.preventDefault();
  if (trigger.classList.contains('ijw-active')) {
    // handled by mini script internally
    trigger.click();
  } else {
    await mountViewer(trigger);
  }
});
